module.exports = __webpack_public_path__ + "0fe5fd8c3c97e0b46526451f06832bf2.png";